import * as React from 'react';
const SvgEyeAllowed = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none" {...props}>
    <path
      fill="#2A9134"
      d="M18.665 8.167C16.998 6.667 14.248 5 10.498 5s-6.5 1.667-8.166 3.167c-.667.5-1 1.333-1 2.166 0 .834.333 1.667 1 2.167 1.666 1.417 4.416 3.167 8.166 3.167s6.5-1.667 8.167-3.167c.666-.5 1-1.333 1-2.167 0-.833-.334-1.666-1-2.166ZM17.58 11.25C16.165 12.5 13.748 14 10.498 14s-5.666-1.5-7.083-2.75c-.25-.25-.417-.583-.417-.917 0-.333.167-.666.417-.916 1.417-1.25 3.833-2.75 7.083-2.75s5.667 1.5 7.083 2.75c.25.166.417.5.417.916 0 .334-.167.667-.417.917Z"
    />
    <path fill="#2A9134" d="M10.498 12.25a1.917 1.917 0 1 0 0-3.833 1.917 1.917 0 0 0 0 3.833Z" />
  </svg>
);
export default SvgEyeAllowed;
